// removed by extract-text-webpack-plugin
module.exports = {"userEligibilityContainer":"userEligibilityContainer__1cxxI","headingTextContainer":"headingTextContainer__1LcwW","userEligibilityTextContainer":"userEligibilityTextContainer__3YShS","textContainer":"textContainer__3F_pn","cardlessEmiText":"cardlessEmiText__1Wa3c","logoImage":"logoImage__1kIam"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/checkEligibilty/userEligibiltycontainer/style.css
// module id = 3+pC
// module chunks = 323